<template>
  <NavBar pageName="UserDetailsView"></NavBar>
  <!--  <div>{{token}}</div>-->
  <!--  <div>{{user}}</div>-->
  <v-spacer class="mt-2"></v-spacer>
  <div>
    <!-- Title and Add New User Button -->
    <div class="">
      <h1>User Details View Page</h1>
    </div>

    <v-row>
      <!--      {{ selectedUser}}-->
      <v-col v-if="userLoaded" cols="12" md="4" lg="3">
        <v-card class="mb-4">
          <v-card-title>
            {{ selectedUser.name }}
          </v-card-title>
          <v-card-subtitle>
            Username: {{ selectedUser.username }}
          </v-card-subtitle>
          <v-card-text>
            <p>Email: {{ selectedUser.email }}</p>
            <p>Created: {{ new Date(selectedUser.created_at).toLocaleString() }}</p>
            <p>Updated: {{ new Date(selectedUser.updated_at).toLocaleString() }}</p>
          </v-card-text>
          <v-card-actions>
           <v-row class="justify-space-around">
             <v-btn color="primary" variant="elevated" @click="openRolesMenu(selectedUser)">Roles</v-btn>
             <v-btn color="success" variant="elevated" @click="showMoreDetails(selectedUser)">Full Details</v-btn>
           </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>


    <!-- Roles Menu -->
    <v-menu v-model="rolesMenuOpen" :close-on-content-click="false">
      <div style="position:fixed;top:70px;left:80%;z-index: 5;">
        <v-btn color="error" variant="elevated" elevation="12" @click="closeRolesMenu">Close</v-btn>
      </div>
      <v-card class="border1" style="width:650px;margin-top:60px;">

        <v-card-title>Roles for {{ selectedUser?.name }}</v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item v-for="role in userRoles" :key="role.role_id">
              <v-row class="flex-row align-content-center justify-start">
                <v-col>
                   <div style="font-size: 18px;width:360px;" :class="role.active==true?'roleActive':'roleInactive'">
                     {{ role.name.toUpperCase() }}
                   </div>
                </v-col>
                <v-col>
                  <v-btn
                      style="width: 150px;"
                      :color="role.active === true ? 'error' : 'success'"
                      @click="toggleRole(role.id)"
                      :loading="role_loading"
                  >
                    {{ role.active === true ? 'Deactivate' : 'Activate' }}
                  </v-btn>
                </v-col>
              </v-row>

            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" @click="closeRolesMenu">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <v-dialog v-model="detailsDialogOpen" max-width="600px">
      <v-card>
        <v-card-title>User Details</v-card-title>
        <v-card-text>
          {{selectedUser}}
          <p>Name: {{ selectedUser?.name }}</p>
          <p>Username: {{ selectedUser?.username }}</p>
          <p>Email: {{ selectedUser?.email }}</p>
          <p>Phone: {{ selectedUser?.phone }}</p>
          <p>Client ID: {{ selectedUser?.client_id }}</p>
          <p>Client: {{ selectedUser?.client_name }}</p>
          <p>Status: {{ selectedUser?.user_status }}</p>
          <!-- Add more fields as needed -->
        </v-card-text>
        <v-card-actions>
          <v-btn color="error"  variant="elevated"  @click="closeDetailsDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <!--      <UsersList v-show="usersListLoaded " @showUsersListEvent="showUsersList"></UsersList>-->
</template>

<script>
import { defineComponent } from 'vue';
import useGetLoggedIn from "@/composables/useGetLoggedIn"
import {log} from "@/composables/useLog";
import NavBar from "@/components/NavBar.vue";
// import UsersList from "@/components/UsersList.vue";
import store from "@/store";
import axios from 'axios'
import {BASE_URL}from "@/composables/url_config";
// Components
import useGetUserRoles from "@/composables/useGetUserRoles";

export default defineComponent({
  name: 'UserDetailsView',
  components: {
    // UsersList,
    NavBar
  },
  data() {
    return {
      showToken:false,
      userLoaded:false,
      token:'',
      user:null,
      currentView:null,
      currentClient:null,
      searchQuery: "",
      rolesMenuOpen: false,
      role_loading: false,
      detailsDialogOpen: false,
      selectedUser: null,
      userRoles: [], // Roles of the currently selected user
    }
  },

  methods: {
    openRolesMenu(user) {
      this.selectedUser = user;
      this.rolesMenuOpen = true;
      this.callGetUserRoles();
    },
    closeRolesMenu() {
      this.rolesMenuOpen = false;
      // this.selectedUser = null;
    },
    async callGetUserRoles() {
      const {getUserRoles}=useGetUserRoles()
      getUserRoles(this.token,this.selectedUser.id).then((response)=>{
        this.userRoles = response.user_roles;
      })
    },
    async toggleRole(role_id) {
      // alert("role_id="+role_id)

      try {
        this.role_loading=true
        const headers = {
          Authorization: `Bearer ${this.token}`,
          "Content-Type": "application/json",

        };
        const params={ role_id:role_id, user_id:this.selectedUser.id }
        const url=BASE_URL+'/home/toggleUserRole'
        log(params)
        // alert("start")
        const response = await axios.post(url, params, { headers });
        log("toggleRole")
        log(response)
        this.role_loading=false
        // alert("stop")

        this.userRoles = response.data.user_roles;
      } catch (error) {
        console.error("Error toggling role:", error);
      }
    },
    showMoreDetails(user) {
      this.selectedUser = user;
      this.detailsDialogOpen = true;
    },
    closeDetailsDialog() {
      this.detailsDialogOpen = false;
      // this.selectedUser = null;
    },
  },
  created() {
    const {getLoggedIn, user, loggedIn, userAvatar,token}=useGetLoggedIn()
    getLoggedIn().then(()=>{
      // timestamp("autorizare in HomeloggedIn after getLoggedIn")
      log ("dupa created in Dashboard avem:")
      log("autorizare in Dashboard after getLoggedIn")
      log("user:")
      log(user)
      log("loggedIn: " + loggedIn.value)
      log("token: " + token.value)
      log("userAvatar: " + userAvatar)
      this.token=token.value
      this.user=user.value
      store.commit('setCurrentView',this.currentView)
      this.selectedUser=store.getters.getSelectedUser
      this.userLoaded=true
      this.showToken=true
      // alert(this.selectedUser.email)
    })
  }
});
</script>
